module.exports = "/images/vendor/desiigner-svg/svg/logos/best-in-travel-2021-stacked.svg?ccd8e1f285bae12969e9d634de03ce5e";